import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

type Dataset = {
  label: string;
  values: number[];
  colors?: string[];
};

function colors(count: number): string[] {
  return Array.from({ length: count }, (_, i) => {
    const hue = Math.round((360 / Math.max(count, 1)) * i);
    return `hsl(${hue} 58% 52%)`;
  });
}

export function ContractCostStackedBarChart({
  xLabels,
  datasets,
  tooltipFormat,
  stacked = true,
}: {
  xLabels: string[];
  datasets: Dataset[];
  tooltipFormat: (n: number) => string;
  stacked?: boolean;
}) {
  if (xLabels.length === 0 || datasets.length === 0) {
    return null;
  }

  const palette = colors(datasets.length);
  const data = {
    labels: xLabels,
    datasets: datasets.map((set, i) => ({
      label: set.label,
      data: set.values,
      backgroundColor: set.colors ?? palette[i],
      stack: "cost",
    })),
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked },
      y: { stacked, beginAtZero: true },
    },
    plugins: {
      legend: {
        position: "right",
        display: datasets.length > 1,
        labels: { boxWidth: 12, font: { size: 11 } },
      },
      tooltip: {
        callbacks: {
          label(ctx) {
            const value = Number(ctx.raw ?? 0);
            return `${ctx.dataset.label}: ${tooltipFormat(value)}`;
          },
        },
      },
    },
  };

  return (
    <div className="w-full h-[480px]">
      <Bar data={data} options={options} />
    </div>
  );
}
